import template from './prems-discount-category-detail-base.html.twig';
import './prems-discount-category-detail-base.scss';

const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

Shopware.Component.register('prems-discount-category-detail-base', {
    template,

    props: {
        discountCategory: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
    },

    data() {
        return {
            validUntilVisibilityValues: [
                'showInProductListingInfobox',
                'showInProductListingPrice',
                'showInProductDetailInfobox',
                'showInProductPagePrice'
            ]
        }
    },

    computed: {
        ...mapPropertyErrors('discountCategory', ['name']),
        categoryIdsModeOptions() {
            return [
                {
                    label: this.$tc('prems-discount-category.detail.card.base.field.categoryIdsMode.disabled'),
                    value: '0',
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.base.field.categoryIdsMode.excluded'),
                    value: '1',
                },
                {
                    label: this.$tc('prems-discount-category.detail.card.base.field.categoryIdsMode.included'),
                    value: '2',
                },
            ];
        },

        validUntilVisibility: {
            get() {
                return this.discountCategory?.validUntilVisibility?.length > 0 ? this.discountCategory.validUntilVisibility : []
            },
            set(value) {
                this.discountCategory.validUntilVisibility = value;
            }
        },

        validUntilVisibilityOptions() {
            return this.validUntilVisibilityValues.map(value => (
                {
                    value,
                    label: this.$tc(`prems-discount-category.detail.card.base.field.validUntilVisibilityOptions.${value}`)
                }
            ));
        }
    },
});